import logger from './logger';
import { DEMO_COMPANY_ID } from '../constants/company';

/**
 * 認証ユーザーから会社IDを取得するヘルパー関数
 * @param user - 認証済みユーザー情報
 * @returns 会社ID（UUIDフォーマット）
 */
export function getCompanyId(user?: { companyId?: string; company?: string } | null): string {
  // 優先順位: companyId（UUID） > company（名前） > デモ会社ID
  if (user?.companyId) {
    return user.companyId;
  }

  // user.companyが会社名の場合は警告を出してデモIDを使用（テスト環境では無効化）
  if (user?.company && user.company !== DEMO_COMPANY_ID && process.env.NODE_ENV !== 'test') {
    logger.warn('[getCompanyId] user.companyが会社名になっています。デモ会社UUIDを使用します。', {
      userCompany: user.company,
      usingDemoId: DEMO_COMPANY_ID,
    });
  }

  return DEMO_COMPANY_ID;
}
